
export default function HeroSection() {
  const scrollToAbout = () => {
    const element = document.getElementById('about');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative h-screen w-full flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/007f7bc53e0940ad9a8bca31c5534ed3/61a69909607b481bd1e262227abc0a72.jpeg"
          alt="Tatsuya Miwa Training"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>
      </div>

      <div className="relative z-10 text-center px-6 w-full max-w-4xl">
        <h1 className="text-5xl sm:text-6xl md:text-8xl font-black text-white mb-4 leading-tight" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>
          My Page
        </h1>

        <button
          onClick={scrollToAbout}
          className="group bg-white/20 backdrop-blur-md text-white px-6 md:px-8 py-3 md:py-4 rounded-full text-sm font-medium hover:bg-white/30 transition-all flex items-center gap-3 mx-auto whitespace-nowrap cursor-pointer"
          style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
        >
          詳しく見る
          <i className="ri-arrow-down-line text-lg group-hover:translate-y-1 transition-transform"></i>
        </button>
      </div>
    </section>
  );
}
